module.exports = __webpack_public_path__ + "static/img/curso_transparencia.1e2214b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/curso_transparencia.png
// module id = s0hj
// module chunks = 9